import { IDashDonorData } from '@nkr/models/index';
import { Utility } from '@nkr/services/utility';
import { Table } from 'react-bootstrap';

interface IProps {
    data: IDashDonorData,
    formattedStartDate: string,
    formattedEndDate: string
}

const Cr1 = (props: IProps) => {
    let { data: donorData, formattedStartDate, formattedEndDate } = props;

    return (
        <Table bordered striped>
            <thead>
                <tr>
                    <th colSpan={3} style={{ background: '#337ab7', color: 'white' }}><span style={{ float: 'left' }}>CR1 </span> <span style={{ float: 'right' }}>({formattedStartDate} - {formattedEndDate})</span></th>
                </tr>
                <tr>
                    <th style={{ backgroundColor: '#f0f0f0' }}>Stage</th>
                    <th style={{ textAlign: 'center', backgroundColor: '#f0f0f0' }}> Total </th>
                    <th style={{ textAlign: 'center', backgroundColor: '#f0f0f0' }}> Percent</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>Registered</td>
                    <td style={{ textAlign: 'center' }}>{donorData.cr1RegisteredCount}</td>
                    <td style={{ textAlign: 'center' }}>--</td>
                </tr>
                <tr>
                    <td>Referred</td>
                    <td style={{ textAlign: 'center' }}>{donorData.cr1ReferredCount}</td>
                    <td style={{ textAlign: 'center' }}>--</td>
                </tr>
                <tr>
                    <td><strong>CR1</strong></td>
                    <td style={{ textAlign: 'center' }}><strong>--</strong></td>
                    <td style={{ textAlign: 'center' }}><strong>{Utility.percent(donorData.cr1ReferredCount, donorData.cr1RegisteredCount)}</strong></td>
                </tr>
            </tbody>
        </Table>
    );
}

export default Cr1;
